/**
 * CSV Parser Utility
 * Parses CSV files with proper handling of quoted fields
 */

export const parseCSVLine = (line) => {
  const result = [];
  let current = '';
  let inQuotes = false;

  for (let i = 0; i < line.length; i++) {
    const char = line[i];
    const nextChar = line[i + 1];

    if (char === '"') {
      if (inQuotes && nextChar === '"') {
        current += '"';
        i++;
      } else {
        inQuotes = !inQuotes;
      }
    } else if (char === ',' && !inQuotes) {
      result.push(current.trim());
      current = '';
    } else {
      current += char;
    }
  }

  result.push(current.trim());
  return result;
};

export const parseCSV = (csvText) => {
  const headers = [];
  const rows = [];
  let currentField = '';
  let inQuotes = false;
  let currentRow = [];

  for (let i = 0; i < csvText.length; i++) {
    const char = csvText[i];
    const nextChar = csvText[i + 1];

    if (char === '"') {
      if (inQuotes && nextChar === '"') {
        currentField += '"';
        i++;
      } else {
        inQuotes = !inQuotes;
      }
    } else if (char === ',' && !inQuotes) {
      currentRow.push(currentField.trim());
      currentField = '';
    } else if ((char === '\r' || char === '\n') && !inQuotes) {
      currentRow.push(currentField.trim());
      currentField = '';
      if (char === '\r' && nextChar === '\n') {
        i++;
      }
      if (currentRow.length > 0 && currentRow.some(x => x !== '')) {
        if (headers.length === 0) {
          headers.push(...currentRow);
        } else {
          const rowObj = {};
          for (let index = 0; index < headers.length; index++) {
            const header = headers[index];
            rowObj[header] = currentRow[index] !== undefined ? currentRow[index] : '';
          }
          rows.push(rowObj);
        }
      }
      currentRow = [];
    } else {
      currentField += char;
    }
  }

  if (currentField.trim() || currentRow.length > 0) {
    currentRow.push(currentField.trim());
    if (headers.length === 0) {
      headers.push(...currentRow);
    } else {
      const rowObj = {};
      for (let index = 0; index < headers.length; index++) {
        const header = headers[index];
        rowObj[header] = currentRow[index] !== undefined ? currentRow[index] : '';
      }
      rows.push(rowObj);
    }
  }

  return { headers, rows };
};

export const normalizeValue = (value) => {
  if (value == null || value === '') return null;
  const str = String(value).trim();
  if (!str) return null;

  const num = Number(str.replace(/,/g, '').replace(/%/g, ''));
  return Number.isFinite(num) ? num : str;
};
